<template>
  <section class="artai-iframe-section">
    <div class="artai-background-container">
      <Header :notificationIconClass="`fa-calendar-check`" v-if="!hideHeader" />

      <ArtAI />
      <!-- <iframe v-show="showFrame" class="iframeWindow" id="the_iframe" ref="the_iframe" src="http://127.0.0.1:5500/prescricao.html" frameborder="0"></iframe> -->
    </div>
    <div class="artai-iframe-footer-wrapper">
      <!-- <img class="foyer-instructions" :src="imageHelp" v-if="imageHelp" alt> -->
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import ArtAI from '@/components/general/ArtAI.vue';

export default {
  name: 'ArtAIView',
  components: {
    Header,
    Footer,
    ArtAI,
  },
  data() {
    return {
      hideHeader: false,
    };
  },

  methods: {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="scss">
.artai-iframe-section {
  background-position: center;
  background-size: cover;
  background-repeat: repeat-y;
}
.artai-background-container {
  // background-color: white;
  min-height: calc(100dvh - 30px);
}

.artai-iframe-footer-wrapper {
  position: fixed;
  bottom: 0px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
